import { makeStyles } from "@mui/styles";
import { CALL_SUPPORT } from "@config/images";
import color from "@definitions/mui/color";

const useStyles = ({ search, isMobile }: { search: string; isMobile: boolean }) => {
  return makeStyles(() => ({
    bannerBody: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
    },
    variantSection: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      flexWrap: "wrap",
      maxWidth: 640,
    },
    variantSectionMobile: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      gap: 2,
    },
    carousel: {
      maxWidth: "100%",
    },
    variantContent: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      textAlign: "center",
    },
    variantText: {
      display: "flex",
      flexDirection: "column",
      textAlign: "start",
      marginLeft: 6,
    },
    sectionHeader: {
      paddingBottom: search ? 0 : isMobile ? "40px" : "40px",
      minHeight: isMobile ? 0 : "100%",
      background:
        search && !isMobile
          ? color.white
          : `linear-gradient(0deg, rgba(46, 67, 77, 0.5), rgba(46, 67, 77, 0.5)),
            url("${CALL_SUPPORT}") ${isMobile ? "12%" : "center"} 35% no-repeat`,
      backgroundSize: "cover",
      ...(isMobile && {
        height: 358,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
      }),
    },
  }))();
};

export default useStyles;
